const STORAGE_KEY = 'zeettu_ui_render_ttl';

function normalize(value: unknown): number {
  const n = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
}

export function saveRequestPacing(value: unknown): void {
  const ms = normalize(value);
  try {
    if (ms > 0) localStorage.setItem(STORAGE_KEY, ms.toString(36));
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage unavailable (private mode / quota); no pacing applied
  }
}

export function readRequestPacing(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? normalize(Number.parseInt(raw, 36)) : 0;
  } catch {
    return 0;
  }
}

export function clearRequestPacing(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
